import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

export const CreateBillsService=async(data)=>{
    try {
        const result = await post(`api/bills/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateBillsService=async(data,id)=>{
    try {
        const result = await put(`api/bills/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadBillsFile=async(data)=>{
    try {
        const result = await postfd(`api/bills/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetBillsService=async(id,type)=>{
    try {
        const result = await get(`api/bills/get/${id}?type=${type}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetAllBillsService=async(page,search,from_date,to_date,step=1)=>{
    try {
        const result = await get(`api/bills/get_all?page=${page}&search=${search}&from_date=${from_date}&to_date=${to_date}&step=${step}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetBillsDetailService=async(id)=>{
    try {
        const result = await get(`api/bills/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeleteBillsService=async(id)=>{
    try {
        const result = await deleteRequest(`api/bills/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}